import { Card, CardContent, Box, Typography } from "@mui/material";
import { BarChart } from "@mui/x-charts/BarChart";
import { TrendingDownIcon } from "../../../../../components/icons/TrendingDownIcon";

const punctualityData = [
  { month: "Jan", value: 240, highlight: false },
  { month: "Feb", value: 180, highlight: false },
  { month: "Mar", value: 200, highlight: false },
  { month: "Apr", value: 150, highlight: false },
  { month: "May", value: 260, highlight: false },
  { month: "Jun", value: 280, highlight: false },
  { month: "Jul", value: 300, highlight: false },
  { month: "Aug", value: 290, highlight: false },
  { month: "Sep", value: 220, highlight: true },
  { month: "Oct", value: 180, highlight: true },
  { month: "Nov", value: 250, highlight: true },
  { month: "Dec", value: 200, highlight: true },
];

// const pScore = 208;

const trendAlert = {
  value: "-10MINS/DAY",
  message:
    "Your punctuality trend is dropping. Arrive early by 10 minutes for 6 days.",
};

export default function PunctualityTrend() {
  const chartData = punctualityData.map((item) => ({
    month: item.month,
    regularValue: !item.highlight ? item.value : null,
    highlightValue: item.highlight ? item.value : null,
  }));

  return (
    <Card sx={{ height: "100%", boxShadow: 0, borderRadius: 3 }}>
      <CardContent sx={{ p: { xs: 2, md: 3 } }}>
        {/* Header Section */}
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="flex-start"
          flexDirection={{ xs: "column", md: "row" }}
          gap={2}
        >
          <Box>
            <Typography
              variant="h6"
              fontWeight="600"
              fontSize={16}
              sx={{ mb: 1 }}
            >
              Punctuality Trend
            </Typography>
            <Box display="flex" alignItems="center" gap={0.5}>
              <Box display="flex" alignItems="center" gap={1}>
                <Box
                  sx={{
                    width: 12,
                    height: 12,
                    //borderRadius: 0.5,
                    backgroundColor: "#BBDEFB",
                  }}
                />
                <Typography variant="caption" color="text.secondary">
                  Last 8 months vs.
                </Typography>
              </Box>
              <Box display="flex" alignItems="center" gap={1}>
                <Box
                  sx={{
                    width: 12,
                    height: 12,
                    //borderRadius: 0.5,
                    backgroundColor: "#2196F3",
                  }}
                />
                <Typography variant="caption" color="text.secondary">
                  Last 4 months
                </Typography>
              </Box>
            </Box>
          </Box>

          <Box
            sx={{
              px: 2,
              py: 1.5,
              borderRadius: 2,
              border: "1px solid #E0E0E0",
              display: "flex",
              alignItems: "center",
              gap: 1.5,
              maxWidth: 320,
            }}
          >
            <Box
              sx={{
                width: 48,
                height: 48,
                borderRadius: "50%",
                backgroundColor: "#BBDEFB",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <TrendingDownIcon
                sx={{ color: "#1E90FF", width: 24, height: 24 }}
              />
            </Box>
            <Box>
              <Typography variant="body2" fontWeight="600" color="#2196F3">
                {trendAlert.value}
              </Typography>
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ fontSize: "0.75rem", lineHeight: 1.3 }}
              >
                {trendAlert.message}
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* Bar Chart */}
        <Box
          sx={{
            height: { xs: 240, sm: 280, md: 320 },
            position: "relative",
            width: "100%",
            overflow: "hidden",
          }}
        >
          <BarChart
            dataset={chartData}
            xAxis={[
              {
                scaleType: "band",
                dataKey: "month",
                disableTicks: true,
                disableLine: false,
              },
            ]}
            yAxis={[
              {
                min: -8,
                max: 320,
                disableTicks: true,
                disableLine: false,
              },
            ]}
            series={[
              { dataKey: "regularValue", color: "#BBDEFB", stack: "total" },
              { dataKey: "highlightValue", color: "#2196F3", stack: "total" },
            ]}
            hideLegend
            // axisHighlight={{
            //   x: "none",
            // }}
            margin={{ top: 40, bottom: 10, left: 10, right: 20 }}
            sx={{
              "& .MuiBarElement-root": {
                rx: 25,
                ry: 25,
                transition: "all 0.3s ease",
              },
              "& .MuiBarElement-root:hover rect": {
                fill: "currentColor",
                opacity: 1,
              },

              "& .MuiChartsAxis-root line": {
                stroke: "#CCCCCC",
                strokeWidth: 1,
              },
              "& .MuiChartsAxis-root path": {
                stroke: "#CCCCCC",
              },

              "& .MuiChartsAxis-tick": {
                display: "none",
              },
              "& .MuiChartsAxis-tickLabel": {
                fontSize: { xs: "0.6rem", sm: "0.75rem" },
                fill: "#666",
                fontWeight: 500,
              },
            }}
          />

          {/* P-Score Reference Line */}
          {/* <Box
            sx={{
              position: "absolute",
              top: "35%", // Adjusted to match the 208 position in the screenshot
              left: 60,
              right: 20,
              height: 1,
              borderTop: "2px dashed #BDBDBD",
              pointerEvents: "none",
              zIndex: 1,
            }}
          />
          <Box
            sx={{
              position: "absolute",
              top: "33%",
              left: "50%",
              transform: "translateX(-50%)",
              backgroundColor: "#FFFFFF",
              border: "1px solid #E0E0E0",
              px: 1.5,
              py: 0.5,
              borderRadius: 4,
              fontSize: "0.8rem",
              fontWeight: 600,
              pointerEvents: "none",
              zIndex: 2,
            }}
          >
            {pScore}
          </Box> */}

          {/* Value label on one of the recent bars (180 as shown) */}
          {/* <Box
            sx={{
              position: "absolute",
              top: "55%", // Positioned near the Oct bar
              left: "75%",
              transform: "translateX(-50%)",
              backgroundColor: "#FFFFFF",
              border: "1px solid #E0E0E0",
              px: 1.5,
              py: 0.5,
              borderRadius: 4,
              fontSize: "0.8rem",
              fontWeight: 600,
              pointerEvents: "none",
              zIndex: 2,
            }}
          >
            180
          </Box> */}
        </Box>
      </CardContent>
    </Card>
  );
}
